/* eslint-disable @typescript-eslint/no-explicit-any */
import { usePostHog } from '@/composables/usePostHog';
import { ENVIRONMENT } from '@/config';
import * as Sentry from '@sentry/vue';
import * as Pinia from 'pinia';

const { posthog } = usePostHog();

export const createException = (error: any) => {
  const isLocalDevelopment = ENVIRONMENT !== 'staging' && ENVIRONMENT !== 'production';
  if (isLocalDevelopment) {
    console.error(error);
  }
  const pinia = Pinia.getActivePinia();
  if (pinia?.state?.value) Sentry.setContext('state', pinia.state.value);

  // Api errors
  if (error?.response?.data) {
    if (error.response.status && error.response.status >= 400 && error.response.status < 500) {
      Sentry.captureMessage(error.response.data, { level: 'warning' });
      return;
    }

    Sentry.captureException(error.response.data);
    return;
  }
  // Other errors
  Sentry.captureException(error);
};

export const createWarning = (error: any) => {
  const isLocalDevelopment = ENVIRONMENT !== 'staging' && ENVIRONMENT !== 'production';
  if (isLocalDevelopment) {
    console.error(error);
  }
  Sentry.captureMessage(error, { level: 'warning' });
};

export const addBreadcrumb = (category: string, message: string) => {
  Sentry.addBreadcrumb({
    category,
    message,
    level: 'info',
  });
};

export const addMetric = (type: string, tags: Record<string, any>) => {
  posthog.capture(type, tags);
};
